export const SITE = {
  name: "幕外",
  fullName: "幕外 · 光影幕后",
  slogan: "把正片之外的每一格，都讲给你听",
  description:
    "幕外是一个专注小电影与短片幕后内容的专题站，持续收录拍摄花絮、幕后故事、导演访谈、片场日记与制作特辑，用番外视角补充正片之外的创作细节。",
  url: "https://0jaukm.cn",
  email: "hello@muwai.example.com",
  topic: "hello@muwai.example.com",
  founded: 2021,
};

export interface Category {
  id: string;
  name: string;
  en: string;
  tagline: string;
}

export const CATEGORIES: Category[] = [
  { id: "bts", name: "拍摄花絮", en: "Behind the Scenes", tagline: "现场捕捉的每一帧NG与灵光" },
  { id: "story", name: "幕后故事", en: "Backstage Stories", tagline: "镜头没能装下的酸甜与巧合" },
  { id: "interview", name: "导演访谈", en: "Director Talk", tagline: "创作者亲述构思与取舍" },
  { id: "diary", name: "片场日记", en: "Set Diary", tagline: "以第一人称回到拍摄现场" },
  { id: "special", name: "制作特辑", en: "Making Of", tagline: "从分镜到成片的完整拆解" },
  { id: "process", name: "创作过程", en: "Creative Process", tagline: "剧本、镜头与声音如何生长" },
];

export function categoryName(id: string): string {
  return CATEGORIES.find((c) => c.id === id)?.name ?? "栏目";
}

export function categoryEn(id: string): string {
  return CATEGORIES.find((c) => c.id === id)?.en ?? "Column";
}